/**
 * pkce.ts
 *
 * Native browser crypto — zero dependencies.
 * Generates a PKCE code_verifier and code_challenge (S256 method).
 */

const base64UrlEncode = (array: Uint8Array): string =>
  btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

/**
 * Generates a cryptographically random code_verifier (43–128 chars, RFC 7636).
 */
export const generateCodeVerifier = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
};

/**
 * Derives the code_challenge from the verifier using SHA-256.
 */
export const generateCodeChallenge = async (
  verifier: string,
): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
};
